import { newspaperCountries } from '@modules/internationalisation/country';
import { SupportRegionId, } from '@modules/internationalisation/countryGroup';
import { gwDeliverableCountries } from '@modules/internationalisation/gwDeliverableCountries';
import { BillingPeriod } from '@modules/product/billingPeriod';
import { isGuardianWeeklyGiftProduct } from 'pages/supporter-plus-thank-you/components/thankYouHeader/utils/productMatchers';
import { multipleAccountsBenefit } from './abTests/multipleAccounts';
import { isObserverSubdomain } from './globalsAndSwitches/observer';
export var ProductTierLabel;
(function (ProductTierLabel) {
    ProductTierLabel["TierOne"] = "Support";
    ProductTierLabel["TierTwo"] = "All-access digital";
    ProductTierLabel["DigitalSubscription"] = "Digital plus";
})(ProductTierLabel || (ProductTierLabel = {}));
const activeProductKeys = [
    'GuardianWeeklyDomestic',
    'GuardianWeeklyRestOfWorld',
    'GuardianAdLite',
    'DigitalSubscription',
    'NationalDelivery',
    'HomeDelivery',
    'SupporterPlus',
    'SubscriptionCard',
    'Contribution',
    'OneTimeContribution',
];
export const productCatalog = window.guardian.productCatalog;
// TODO: we should probably move into using this function so we can acess the an updated version of the product catalog
export const getProductCatalog = () => window.guardian.productCatalog;
export const showSimilarProductsConsentForRatePlan = (productDescription, ratePlanKey) => !productDescription.ratePlans[ratePlanKey]?.hideSimilarProductsConsent;
export function filterBenefitByRegion(benefit, countryGroupId) {
    if (benefit.specificToRegions !== undefined) {
        return benefit.specificToRegions.includes(countryGroupId);
    }
    return true;
}
export function isProductKey(val) {
    return activeProductKeys.includes(val);
}
const appBenefit = {
    copy: 'Unlimited access to the Guardian app',
    tooltip: `Read beyond our 10 article-per-month limit, enjoy offline access and personalised recommendations, and access our full archive of journalism. Never miss a story with the Guardian News app – a beautiful, intuitive reading experience.`,
};
const addFreeBenefit = {
    copy: 'Ad-free reading on all your devices',
};
const supportBenefit = {
    copy: 'Give to the Guardian every month with Support',
    specificToRegions: [
        'GBPCountries',
        'EURCountries',
        'AUDCountries',
        'NZDCountries',
        'Canada',
        'International',
    ],
    hideBullet: true,
};
const newsletterBenefitUS = {
    copy: 'Regular dispatches from the newsroom to see the impact of your support',
    specificToRegions: ['UnitedStates'],
};
const newsletterBenefit = {
    copy: 'Exclusive newsletter for supporters, sent every week from the Guardian newsroom',
    specificToRegions: [
        'GBPCountries',
        'EURCountries',
        'AUDCountries',
        'NZDCountries',
        'Canada',
        'International',
    ],
};
const fewerAsksBenefit = {
    copy: 'Far fewer asks for support',
    tooltip: `You'll see far fewer financial support asks at the bottom of articles or in pop-up banners.`,
};
const partnerOffersBenefit = {
    copy: 'Exclusive access to partner offers',
    tooltip: 'Access to special offers (such as free and discounted tickets) from our values-aligned partners, including museums, festivals and cultural institutions.',
    specificToRegions: ['AUDCountries'],
};
const guardianWeeklyBenefit = {
    copy: 'Guardian Weekly print magazine delivered to your door every week',
    tooltip: `Guardian Weekly is a beautifully concise magazine featuring a handpicked selection of in-depth articles, global news, long reads, opinion and more. Delivered to you every week, wherever you are in the world.`,
};
const guardianWeeklyGiftBenefit = {
    copy: `Guardian Weekly print magazine delivered to your recipient's door`,
};
const feastBenefit = {
    copy: 'Unlimited access to the Guardian Feast app',
    tooltip: 'Make a feast out of anything with the Guardian’s new recipe app. Feast has thousands of recipes including quick and budget-friendly weeknight dinners, and showstopping weekend dishes – plus smart app features to make mealtimes inspiring.',
    label: { copy: 'New' },
};
const supporterPlusBenefits = [
    fewerAsksBenefit,
    addFreeBenefit,
    appBenefit,
    newsletterBenefit,
    newsletterBenefitUS,
    partnerOffersBenefit,
    feastBenefit,
];
const guardianAdLiteBenefits = [
    {
        copy: 'A Guardian Ad-Lite subscription enables you to read the Guardian website without personalised advertising (except for when we host third party content, like videos).',
    },
    {
        copy: 'You will still see non-personalised advertising.',
    },
    { copy: 'You can cancel at any time.' },
];
const paperThankyouMessage = `Look out for an email from us confirming your subscription. It has everything you need to know about how to manage it in the future. As well as future communications on how to make the most of your subscription and weekly newsletters written by the editors. `;
const digitalThankyouMessage = `You'll receive a confirmation email containing everything you need to know about your subscription, including additional emails on how to make the most of your subscription.${' '}`;
const nationalPaperPlusRatePlans = {
    Everyday: {
        billingPeriod: BillingPeriod.Monthly,
        displayName: 'Every day package',
        label: 'every day',
    },
    EverydayPlus: {
        billingPeriod: BillingPeriod.Monthly,
        displayName: 'Every day package',
        label: 'every day',
    },
    Sixday: {
        billingPeriod: BillingPeriod.Monthly,
        displayName: 'Six day package',
        label: 'six day',
    },
    SixdayPlus: {
        billingPeriod: BillingPeriod.Monthly,
        displayName: 'Six day package',
        label: 'six day',
    },
    Weekend: {
        billingPeriod: BillingPeriod.Monthly,
        displayName: 'Weekend package',
        label: 'weekend',
    },
    WeekendPlus: {
        billingPeriod: BillingPeriod.Monthly,
        displayName: 'Weekend package',
        label: 'weekend',
    },
};
const isObserverSubDomain = isObserverSubdomain();
const paperPlusRatePlans = {
    ...nationalPaperPlusRatePlans,
    Saturday: {
        billingPeriod: BillingPeriod.Monthly,
        displayName: 'Saturday package',
        label: 'saturday',
    },
    SaturdayPlus: {
        billingPeriod: BillingPeriod.Monthly,
        displayName: 'Saturday package',
        label: 'saturday',
    },
    Sunday: {
        billingPeriod: BillingPeriod.Monthly,
        displayName: `The Observer${isObserverSubDomain ? ', digital & print' : ''}`,
        label: 'Observer',
        hideSimilarProductsConsent: true,
    },
    SundayPlus: {
        billingPeriod: BillingPeriod.Monthly,
        displayName: `The Observer${isObserverSubDomain ? ', digital & print' : ''}`,
        label: 'Observer',
        hideSimilarProductsConsent: true,
    },
};
const digitalPaperBenefitUK = {
    copy: 'Daily digital Guardian newspaper',
    specificToRegions: ['GBPCountries'],
};
const paperArchiveDigitalBenefitUK = {
    copy: `Digital access to the Guardian’s 200 year newspaper archive`,
    tooltip: 'Look back on more than 200 years of world history with the Guardian newspaper archive. Get digital access to every front page, article and advertisement, as it was in the UK, since 1821.',
    specificToRegions: ['GBPCountries'],
};
const weeklyDigitalBenefit = {
    copy: `Guardian Weekly digital magazine`,
    tooltip: `Accessed through the Guardian Editions app, the Guardian Weekly e-magazine features a handpicked and carefully curated selection of in-depth articles, global news, opinion and more. Enjoy wherever you are, on your favourite device.`,
};
const editionsDigitalBenefit = {
    copy: `The Long Read digital magazine`,
    tooltip: `Accessed through the Guardian Editions app, the Long Read is a quarterly curated magazine with some of the Guardian’s finest longform journalism. Its narrative storytelling and investigative reporting seeks to debunk myths and uncover hidden histories.`,
};
const paperArchiveDigitalBenefit = {
    copy: `Digital access to the Guardian’s 200 year newspaper archive`,
    tooltip: 'Look back on more than 200 years of world history with the Guardian newspaper archive. Get digital access to every front page, article and advertisement, as it was, since 1821.',
    specificToRegions: [
        'UnitedStates',
        'EURCountries',
        'AUDCountries',
        'NZDCountries',
        'Canada',
        'International',
    ],
};
export const tooltipMultipleAccounts = `You can share your Digital plus access with three other people. Each person gets their own account and login.`;
const multipleAccountBenefit = {
    copy: multipleAccountsBenefit,
    tooltip: tooltipMultipleAccounts,
    label: { copy: 'New' },
};
export const productCatalogDescription = {
    GuardianAdLite: {
        label: 'Guardian Ad-Lite',
        thankyouMessage: `Your subscription powers our journalism.`,
        landingPagePath: '/guardian-ad-lite',
        ratePlans: {
            Monthly: {
                billingPeriod: BillingPeriod.Monthly,
                hideSimilarProductsConsent: true,
            },
        },
        benefits: guardianAdLiteBenefits,
    },
    DigitalSubscription: {
        label: 'Digital plus',
        labelPill: 'New',
        thankyouMessage: digitalThankyouMessage,
        landingPagePath: '/contribute',
        benefits: [
            multipleAccountBenefit,
            paperArchiveDigitalBenefit,
            paperArchiveDigitalBenefitUK,
            digitalPaperBenefitUK,
            weeklyDigitalBenefit,
            editionsDigitalBenefit,
        ],
        ratePlans: {
            Monthly: {
                billingPeriod: BillingPeriod.Monthly,
            },
            MonthlyTaxExclusive: {
                billingPeriod: BillingPeriod.Monthly,
            },
            Annual: {
                billingPeriod: BillingPeriod.Annual,
            },
            AnnualTaxExclusive: {
                billingPeriod: BillingPeriod.Annual,
            },
            ThreeMonthGift: {
                billingPeriod: BillingPeriod.Monthly,
            },
            OneYearGift: {
                billingPeriod: BillingPeriod.Annual,
            },
        },
    },
    SupporterPlus: {
        label: ProductTierLabel.TierTwo,
        landingPagePath: '/contribute',
        benefits: supporterPlusBenefits,
        ratePlans: {
            Monthly: {
                billingPeriod: BillingPeriod.Monthly,
            },
            MonthlyTaxExclusive: {
                billingPeriod: BillingPeriod.Monthly,
            },
            Annual: {
                billingPeriod: BillingPeriod.Annual,
            },
            AnnualTaxExclusive: {
                billingPeriod: BillingPeriod.Annual,
            },
            OneYearStudent: {
                billingPeriod: BillingPeriod.Annual,
                fixedTerm: true,
            },
        },
    },
    GuardianWeeklyRestOfWorld: {
        label: 'The Guardian Weekly',
        landingPagePath: '/subscribe/weekly',
        benefits: [guardianWeeklyBenefit],
        deliverableTo: gwDeliverableCountries,
        ratePlans: {
            Monthly: {
                billingPeriod: BillingPeriod.Monthly,
            },
            MonthlyPlus: {
                billingPeriod: BillingPeriod.Monthly,
            },
            OneYearGift: {
                billingPeriod: BillingPeriod.Annual,
                hideSimilarProductsConsent: true,
                fixedTerm: true,
            },
            Annual: {
                billingPeriod: BillingPeriod.Annual,
            },
            AnnualPlus: {
                billingPeriod: BillingPeriod.Annual,
            },
            Quarterly: {
                billingPeriod: BillingPeriod.Quarterly,
            },
            QuarterlyPlus: {
                billingPeriod: BillingPeriod.Quarterly,
            },
            ThreeMonthGift: {
                billingPeriod: BillingPeriod.Quarterly,
                hideSimilarProductsConsent: true,
                fixedTerm: true,
            },
        },
    },
    GuardianWeeklyDomestic: {
        label: 'The Guardian Weekly',
        landingPagePath: '/subscribe/weekly',
        benefits: [guardianWeeklyBenefit],
        deliverableTo: gwDeliverableCountries,
        ratePlans: {
            Monthly: {
                billingPeriod: BillingPeriod.Monthly,
            },
            MonthlyPlus: {
                billingPeriod: BillingPeriod.Monthly,
            },
            OneYearGift: {
                billingPeriod: BillingPeriod.Annual,
                hideSimilarProductsConsent: true,
                fixedTerm: true,
            },
            Annual: {
                billingPeriod: BillingPeriod.Annual,
            },
            AnnualPlus: {
                billingPeriod: BillingPeriod.Annual,
            },
            Quarterly: {
                billingPeriod: BillingPeriod.Quarterly,
            },
            QuarterlyPlus: {
                billingPeriod: BillingPeriod.Quarterly,
            },
            ThreeMonthGift: {
                billingPeriod: BillingPeriod.Quarterly,
                hideSimilarProductsConsent: true,
                fixedTerm: true,
            },
        },
    },
    SubscriptionCard: {
        label: 'Collect in store with a subscription card',
        thankyouMessage: paperThankyouMessage,
        landingPagePath: '/subscribe/paper',
        benefits: [],
        deliverableTo: newspaperCountries,
        ratePlans: paperPlusRatePlans,
    },
    HomeDelivery: {
        label: 'Home delivery',
        thankyouMessage: paperThankyouMessage,
        landingPagePath: '/subscribe/paper',
        benefits: [],
        deliverableTo: newspaperCountries,
        ratePlans: paperPlusRatePlans,
    },
    NationalDelivery: {
        label: 'National delivery',
        thankyouMessage: paperThankyouMessage,
        landingPagePath: '/subscribe/paper',
        benefits: [],
        deliverableTo: newspaperCountries,
        ratePlans: nationalPaperPlusRatePlans,
    },
    Contribution: {
        label: ProductTierLabel.TierOne,
        landingPagePath: '/contribute',
        benefits: [supportBenefit, newsletterBenefitUS],
        ratePlans: {
            Monthly: {
                billingPeriod: BillingPeriod.Monthly,
            },
            Annual: {
                billingPeriod: BillingPeriod.Annual,
            },
        },
    },
    OneTimeContribution: {
        label: 'One-time contribution',
        landingPagePath: '/contribute',
        benefits: [fewerAsksBenefit],
        // Omit one time rate plans for now. We don't expect to use this data and the types in support-frontend
        // can't handle a billingPeriod of OneTime.
        ratePlans: {},
    },
};
export function productCatalogGuardianAdLite() {
    return {
        ...productCatalogDescription,
        GuardianAdLite: {
            ...productCatalogDescription.GuardianAdLite,
            label: 'Purchase Guardian Ad-Lite',
        },
        GuardianAdLiteGoBack: {
            ...productCatalogDescription.GuardianAdLite,
            label: 'Read the Guardian with personalised ads',
            benefits: [
                {
                    copy: `Click ‘Go back to Accept all’ if you do not want to subscribe to Guardian Ad-Lite.`,
                    hideBullet: true,
                },
            ],
        },
    };
}
const productCatalogGuardianWeeklyGift = {
    ...productCatalogDescription,
    GuardianWeeklyDomestic: {
        ...productCatalogDescription.GuardianWeeklyDomestic,
        benefits: [guardianWeeklyGiftBenefit],
    },
    GuardianWeeklyRestOfWorld: {
        ...productCatalogDescription.GuardianWeeklyRestOfWorld,
        benefits: [guardianWeeklyGiftBenefit],
    },
};
export const getProductLabel = (productKey) => {
    return productCatalogDescription[productKey].label;
};
export const getProductDescription = (productKey, ratePlanKey) => {
    if (isGuardianWeeklyGiftProduct(productKey, ratePlanKey)) {
        return productCatalogGuardianWeeklyGift[productKey];
    }
    return productCatalogDescription[productKey];
};
/**
 * This method is to help us determine which product and rateplan to
 * use based on a person's internationalisation ID.
 *
 * The reason this exists is because we have different pricing for
 * `int` and `us` for SupporterPlus and GuardianWeekly, but they
 * both use `USD`.
 *
 * As Zuora is restricted to only being able to vary on currency,
 * we express this in the product catalog by having different products
 * for GuardianWeekly, and different ratePlans for SupporterPlus.
 *
 * We are potentially going to look at Attribute based pricing in the future.
 *
 * @see: https://knowledgecenter.zuora.com/Zuora_Billing/Build_products_and_prices/Attribute-based_pricing/AA_Overview_of_Attribute-based_Pricing
 * */
export function internationaliseProductAndRatePlan(supportRegionId, productKey, ratePlanKey) {
    return {
        productKey: internationaliseProduct(supportRegionId, productKey),
        ratePlanKey: ratePlanKey,
    };
}
export function internationaliseProduct(supportRegionId, productKey) {
    if (productKey === 'GuardianWeeklyDomestic' ||
        productKey === 'GuardianWeeklyRestOfWorld') {
        if (supportRegionId === SupportRegionId.INT) {
            return 'GuardianWeeklyRestOfWorld';
        }
        else {
            return 'GuardianWeeklyDomestic';
        }
    }
    return productKey;
}
